import React, { useState } from "react";
import Login from "./Login";
import OtpVerifyScreen from "./OtpVerifyScreen";

function LoginIndex() {
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");
  const [otpRefCode, setOtpRefCode] = useState("");

  return (
    <>
      {step === 0 ? (
        <Login
          onSuccess={(email, otpRefCode) => {
            setStep(1);
            setEmail(email);
            setOtpRefCode(otpRefCode);
          }}
        />
      ) : (
        <OtpVerifyScreen email={email} otpRefCode={otpRefCode} />
      )}
    </>
  );
}
export default LoginIndex;
